/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import OverlayContainerWithMaterialUi from "./OverlayContainerWithMaterialUi";
import { Stack } from "@mui/material";
import { getCouponListApi } from "../../service/ZohoPlanService";
const ZohoCouponsModal = ({
  open,
  onClose,
  planCode,
  onApplyCoupon,
  selectedPlan,
}) => {
  const [couponList, setCouponList] = useState([]);
  const getCouponList = async () => {
    try {
      const data = await getCouponListApi(planCode);
      setCouponList(data?.data || []);
      //   setCouponList([
      //     {
      //       discount_type: "flat",
      //       discount_value: 100,
      //       plans: [{ name: "Basic" }],
      //       name: "BASIC100",
      //     },
      //     {
      //       discount_type: "",
      //       discount_value: 200,
      //       plans: [{ name: "Pro" }],
      //       name: "PRO200",
      //     },
      //   ]);
    } catch (error) { }
  };

  console.log(couponList, "newdata");
  useEffect(() => {
    getCouponList();
  }, []);
  return (
    <OverlayContainerWithMaterialUi open={open} setClose={onClose}>
      <div className="zoho-coupon-container">
        <div className="zoho-header">
          <h2>Coupon Code</h2>
          <button onClick={onClose}>{/* <CrossIcon /> */}</button>
        </div>
        {couponList.length ?
          <>
            <h4 className="sub-header">Best Offers for you</h4>
            {couponList.map((item) => (
              <div className="coupon-card" key={item?.name}>
                <div className="coupon-content">
                  {/* <MdDiscount fontSize={20} /> */}
                  <div className="coupon-details">
                    <h4>
                      {item?.discount_type === "flat"
                        ? `Flat ₹${item?.discount_value} OFF on ${item?.plans?.[0]?.name} Plan`
                        : `${item?.discount_value}% OFF on ${item?.plans?.[0]?.name} Plan`}
                    </h4>
                    <h5>
                      {item?.discount_type === "flat"
                        ? `Save Flat ₹${item?.discount_value} with this code`
                        : `Save over ${item?.discount_value}% with this code`}
                    </h5>
                    <div className="coupon-actions">
                      <button className="coupon-code">{item?.name}</button>
                      <button
                        className="apply-button"
                        onClick={() => onApplyCoupon(item)}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
          :
          <Stack textAlign={'center'} sx={{ width: '100%' }}>
            <h4 className="sub-header"> No offers available for you now. </h4>
          </Stack>
        }
      </div>
    </OverlayContainerWithMaterialUi>
  );
};

export default ZohoCouponsModal;
